import loadable from '@loadable/component'

export default {
  '/:type/open/:product_id/lessons/:lesson_id': loadable(() => import('./LessonsVideo')),
  '/:type/wangshou/:product_id/lessons/:lesson_id': loadable(() => import('./LessonsVideo')),
  '/:type/mianshou/:product_id/lessons/:lesson_id': loadable(() => import('./LessonsVideo')),
  '/:type/book/:product_id/lessons/:lesson_id': loadable(() => import('./LessonsVideo')),
  '/:type/recommend/:product_id/lessons/:lesson_id': loadable(() => import('./LessonsVideo')),
  '/:type/open': loadable(() => import('./openClassList')),
}
